const valuesTitleDict = {
  goodTradeInValue: "Excellent",
  fairTradeInValue: "Average",
  poorTradeInValue: "Below Average"
};

const formatCondition = conditionValue => valuesTitleDict[conditionValue] || "";

export default formatCondition;
